import { SVGProps } from 'react'

export const Share = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      d="M13.334 4.167L12.15 5.35l-1.325-1.325v9.309h-1.65V4.025L7.85 5.35 6.667 4.167 10 .833l3.334 3.334zm3.333 4.167V17.5c0 .917-.75 1.667-1.667 1.667H5c-.925 0-1.667-.75-1.667-1.667V8.334A1.66 1.66 0 015 6.667h2.5v1.667H5V17.5h10V8.334h-2.5V6.667H15c.917 0 1.667.742 1.667 1.667z"
    ></path>
  </svg>
)
